<template>
    <div class="select_dialog_embed">
      <div class="after_sales_embed_msg"
           :class="{'w_percent96': showType === 'modifySalesDetail' || afterSalesTypeOrderDetail,
            'topWpre5': showType === 'modifySalesDetail'}">
        <div class="select_dialog_embed_box"
             :class="{'w650' : showType === 'log' || showType === 'createExchange',
             'w800' : showType === 'logisticNumDetail',
             'w_percent100': showType === 'modifySalesDetail' || afterSalesTypeOrderDetail}">
          <!--弹出框头部-->
          <div v-if="!afterSalesTypeOrderDetail" class="select_dialog_embed_box_top">
            <p>{{title}}</p>
          </div>
          <div v-if="afterSalesTypeOrderDetail" class="select_dialog_embed_box_top">
            <p>选择售后明细</p>
          </div>

          <!--弹出框信息-->
          <!--撤回-->
          <div v-if="showType === 'pullBack'" class="select_dialog_embed_box_content">
            <p class="text_center pt30 pb20">是否将选择的售后单撤回到待受理状态？</p>
          </div>

          <!--终止售后-->
          <div v-if="showType === 'closeSalesAfter'" class="select_dialog_embed_box_content">
            <p class="text_center pt30 pb20">是否关闭终止选择到的售后单？</p>
          </div>

          <!--受理-->
          <div v-if="showType === 'toAccept'" class="select_dialog_embed_box_content pl20 pr20">
            <div class="mt20 mb10">
              <span class="inb w99 text_right">售后单号：</span>
              <label>{{msg.RefundId}}</label>
            </div>
            <div class="mb10">
              <span class="inb w99 text_right">售后类型：</span>
              <label>{{msg.ReTypeName}}</label>
            </div>
            <div v-if="msg.ReTypeName === '退货' || msg.ReTypeName === '换货' || msg.ReTypeName === '漏发'" class="mb10">
              <span class="inb w99 text_right">额外退费金额：</span>
              <div class="inb w84">
                <input type="text" title="退款金额" v-model.number="msg.PXExtMoney" :disabled="msg.IsDefault">
              </div>
              <div class="inb fcDel">订单在平台下单运费：{{msg.CourierFee}}元</div>
            </div>
            <div v-if="msg.ReTypeName === '退货' || msg.ReTypeName === '换货' || msg.ReTypeName === '漏发'" class="mb10">
              <span class="inb w99 text_right">受理退货渠道：</span>
              <div class="inb w150">
                <el-select v-model="selectAcceptanceChannel" @change="getAgentStoreroomById" placeholder="受理渠道">
                  <el-option v-for="item in acceptanceChannelList"
                             :key="item.id"
                             :label="item.text"
                             :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="msg.ReTypeName === '退货' || msg.ReTypeName === '换货'"  class="mb10" style="margin-left: 85px;">
              <input type="checkbox" v-model="isOriginalReturn" title="原返">
              <label for="notLoginUser">原返</label>
            </div>
            <div v-if="msg.ReTypeName === '退货' || msg.ReTypeName === '换货' || msg.ReTypeName === '漏发'" class="mb10 vertical_center">
              <span class="inb w99 text_right">渠道收货信息：</span>
              <textarea class="w280 h100" placeholder="输入框限制最多只能输入200个字符。" maxlength="200" v-model.trim="channelReceivingInfo"></textarea>
            </div>
            <div class="mb10 vertical_center">
              <span class="inb w99 text_right">售后留言：</span>
              <textarea class="w280 h100" placeholder="输入框限制最多只能输入200个字符。" maxlength="200" v-model.trim="salesRemark"></textarea>
            </div>
          </div>

          <!--日志-->
          <div v-if="showType === 'log'" class="select_dialog_embed_box_content log">
            <table class="table tb_border">
              <thead>
              <tr>
                <th>操作人</th>
                <th>操作时间</th>
                <th>操作内容</th>
              </tr>
              </thead>
              <tbody v-if="logList.length">
              <tr v-for="(item, index) in logList" :key="index">
                <td>{{item.CreaterUserName}}</td>
                <td>{{item.CreateTime | time}}</td>
                <td>{{item.Info}}</td>
              </tr>
              </tbody>
              <tbody v-if="!logList.length">
              <tr>
                <td colspan="3">{{logErr}}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <!--创建换货新订单-->
          <div v-if="showType === 'createExchange'" class="select_dialog_embed_box_content mt10 mr10 mb10 ml10">
            <!--<p class="text_center mt30 mb20">是否创建换货新订单？</p>-->
            <table class="table">
              <colgroup><col style="width: 100%"></colgroup>
              <thead>
              <tr>
                <th>货号</th>
                <th>品名</th>
                <th>颜色</th>
                <th>尺码</th>
              </tr>
              </thead>
            </table>
            <table class="table">
              <colgroup><col style="width: 100%"></colgroup>
              <tbody>
              <tr v-for="(item, index) in orderList" :key="index">
                <td><input type="text" title="货号"
                           v-model="item.GoodsId"
                           @blur="getGoodsInfoByGoodsId(item.GoodsId, index)"
                           @keyup.enter="getGoodsInfoByGoodsId(item.GoodsId, index)"
                           maxlength="50"></td>
                <td>{{item.GoodsName}}</td>
                <td><input type="text" title="颜色" maxlength="50" v-model="item.ColorName"></td>
                <td><input type="text" title="尺码" maxlength="50" v-model="item.SizeName"></td>
              </tr>
              </tbody>
            </table>
          </div>

          <!--修改明细-->
          <div v-if="showType === 'modifySalesDetail' || afterSalesTypeOrderDetail" class="select_dialog_embed_box_content pl5 pr5">
            <div class="pl40 mt20 mb10">
              <span>选择订单号：</span>
              <div class="inb">
                <el-select v-model="selectOrderNum" @change="getOrderData(selectOrderNum)" placeholder="选择订单号">
                  <el-option v-for="item in orderList"
                             :key="item.OrderId"
                             :label="item.OrderId"
                             :value="item.OrderId">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="pl40 mb10">
              <span>发出渠道：</span>
              <!--{{orderMsg.SupplierCode}}_{{orderMsg.StoreroomName}}-->
              {{orderMsg.StoreroomName}}
            </div>
            <table class="table tb_border">
              <thead>
              <tr>
                <th></th>
                <th>品名</th>
                <th>货号</th>
                <th>尺码</th>
                <th>数量</th>
                <th>市场价</th>
                <th>成交单价</th>
                <th>优惠金额</th>
                <th>合计</th>
                <th>拿货单价</th>
                <th>拿货单价合计</th>
                <th>错发货号</th>
                <th>错发尺码</th>
                <th>错发？</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in orderMsg.OrderDetailList" :key="index">
                <td><i class="iconfont icon-del fcDel" @click="delOrderGoods(index)"></i></td>
                <td>{{item.GoodsName}}</td>
                <td>{{item.GoodsId}}</td>
                <td>{{item.SizeName}}</td>
                <!--<td><input class="w40" type="number" min="1" step="1" v-model.number="item.SendQuantity" @input="changeQuantity(index)"></td>-->
                <td><input class="w40" type="number" min="1" step="1" title="数量" v-model.number="item.Quantity" @input="changeQuantity(index)"></td>
                <td>{{item.MarkPrice}}</td>
                <!--<td>{{item.PayFee}}</td>-->
                <td>{{item.UnitPrice}}</td>
                <td><input class="w60" type="text" title="优惠金额" v-model.number="item.OfferFee" @input="changeQuantity(index)"></td>
                <td>{{item.clinchADealUnitpriceRow}}</td>
                <td>{{item.AgentCostPrice}}</td>
                <td>{{item.takeAUnitPriceOfGoodsRow}}</td>
                <td><input class="w60" type="text" title="错发货号" v-model.trim="item.errorGoodsNum"></td>
                <td><input class="w60" type="text" title="错发尺码" v-model.trim="item.errorSize"></td>
                <td><input type="checkbox" title="错发" v-model="item.isError"></td>
              </tr>
              <tr>
                <td colspan="7" class="fcBlue">注意：以上是您需要退、换或漏发的货品，请慎重选择！如果选择错发，收货时系统以错发货品进行收货验证！</td>
                <td>合计</td>
                <td>{{orderMsg.clinchADealUnitpriceCol}}</td>
                <td></td>
                <td>{{orderMsg.takeAUnitPriceOfGoodsCol}}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>

          <!--修改售后类型-->
          <div v-if="showType === 'modifyAfterSalesType' && !afterSalesTypeOrderDetail" class="select_dialog_embed_box_content text_center pt40 pb30">
            <span>售后类型：</span>
            <div class="inb">
              <el-select v-model="selectAfterSalesType" placeholder="售后类型">
                <el-option v-for="item in afterSalesTypeList"
                           :key="item.id"
                           :label="item.text"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>

          <!--修改售后类型-->
          <div v-if="showType === 'modifySalesReasonList'" class="select_dialog_embed_box_content text_center pt40 pb30">
            <span>售后原因：</span>
            <div class="inb">
              <el-select v-model="selectAfterSalesReason" placeholder="售后原因">
                <el-option v-for="item in afterSalesReasonList"
                           :key="item.id"
                           :label="item.text"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>

          <!--退回物流信息-->
          <div v-if="showType === 'returnLogistic' && txtMsg !== '退回物流'" class="select_dialog_embed_box_content text_center pt40 pb30">
            <div class="mb20">
              <span class="inb w99 text_right">物流公司：</span>
              <div class="inb w212">
                <el-select v-model="selectCourierCompany" placeholder="快递公司">
                  <el-option v-for="item in courierCompanyList"
                             :key="item.id"
                             :label="item.text"
                             :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="mb20">
              <span class="inb w99 text_right">退货运单号：</span>
              <div class="inb w212">
                <input type="text" title="退货运单号" maxlength="50" v-model.trim="logisticNum">
              </div>
            </div>
           <!-- <div>
              <span class="inb w99 text_right">额外退费金额：</span>
              <div class="inb w212">
                <input type="text" title="额外退费金额" maxlength="50" v-model.number="extraRefund" @input="judgeNum()">
              </div>
            </div>
            <p class="text_center fcDel">订单在平台下单运费：{{msg.CourierFee}}元</p> -->
          </div>

          <!--确认是否退回物流-->
          <div v-if="(showType === 'returnLogistic' || showType === 'modifyReturnLogistic') && txtMsg === '退回物流'" class="select_dialog_embed_box_content text_center pt40 pb30">
            当前退回运单号已被使用过，{{error}}确定继续保存？
          </div>

          <!--编辑退回物流信息-->
          <div v-if="showType === 'modifyReturnLogistic' && txtMsg !== '退回物流'" class="select_dialog_embed_box_content text_center pt40 pb30">
            <div class="mb20">
              <span class="inb w99 text_right">物流公司：</span>
              <div class="inb w212">
                <el-select v-model="selectCourierCompany" placeholder="快递公司">
                  <el-option v-for="item in courierCompanyList"
                             :key="item.id"
                             :label="item.text"
                             :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="mb20">
              <span class="inb w99 text_right">退货运单号：</span>
              <div class="inb w212">
                <input type="text" title="退货运单号" maxlength="50" v-model.trim="logisticNum">
              </div>
            </div>
           <!-- <div>
              <span class="inb w99 text_right">额外退费金额：</span>
              <div class="inb w212">
                <input type="text" title="额外退费金额" maxlength="50" v-model.number="extraRefund" @input="judgeNum()">
              </div>
            </div> -->
            <!--<p class="text_center fcDel">订单在平台下单运费：{{msg.CourierFee}}元</p>-->
          </div>

          <!--编辑额外退费金额-->
          <div v-if="showType === 'extraRefund'" class="select_dialog_embed_box_content text_center pt40 pb30">
            <span>额外退费金额：</span>
            <div class="inb w212">
              <input type="text" title="额外退费金额" maxlength="20" v-model.number="extraRefund" @input="judgeNum()">
            </div>
            <p class="fcDel mt10">订单在平台下单运费：12元</p>
          </div>

          <!--编辑已退费金额-->
          <div v-if="showType === 'buyerRefundedAmount'" class="select_dialog_embed_box_content text_center pt40 pb30">
            <span>已退款买家金额：</span>
            <div class="inb w212">
              <input type="text" title="额外退费金额" maxlength="20" v-model.number="extraRefund" @input="judgeNum()">
            </div>
          </div>

          <!--编辑备注-->
          <div v-if="showType === 'modifyRemark'" class="select_dialog_embed_box_content pt20 pb10 vertical_center" style="justify-content: center">
            <span>备注：</span>
            <textarea class="w250 h150" placeholder="输入框限制最多只能输入200个字符。" maxlength="200" v-model.trim="modifyRemark"></textarea>
          </div>

          <!--确认收货-->
          <div v-if="showType === 'confirmReceipt'" class="select_dialog_embed_box_content pt10 pr10 pb10 pl10">
            <p class="mt10 mb10"><i class="iconfont icon-warn fcDel mr10"></i>确认一下退回商品是否都已完成收货？</p>
            <table class="table tb_border">
              <thead>
              <tr>
                <th>品名</th>
                <th>货号</th>
                <th>尺码</th>
                <th>数量</th>
                <th>错发货号</th>
                <th>错发尺码</th>
                <th>是否错发</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="!logisticDetailListErr" v-for="(item, index) in logisticDetailList" :key="index">
                <td>{{item.GoodsName}}</td>
                <td>{{item.GoodsId}}</td>
                <td>{{item.SizeName}}</td>
                <td>{{item.Quantity}}</td>
                <td>{{item.WrongSendGoodsId}}</td>
                <td>{{item.WrongSendSize}}</td>
                <td v-if="item.WrongSendSkuId">是</td>
                <td v-if="!item.WrongSendSkuId">否</td>
              </tr>
              <tr v-if="!logisticDetailListErr && !logisticDetailList.length">
                <td colspan="5">暂时没有相关信息</td>
              </tr>
              <tr v-if="logisticDetailListErr">
                <td colspan="5">{{logisticDetailListErr}}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <!--重新提交-->
          <div v-if="showType === 'resubmit'" class="select_dialog_embed_box_content">
            <p class="text_center pt30 pb20">是否重新提交选择到的售后单？</p>
          </div>

          <!--运单号的详细信息-->
          <div v-if="showType === 'logisticNumDetail'" class="select_dialog_embed_box_content pt10 pr10 pb10 pl10">
            <table class="table tb_border">
              <thead>
              <tr>
                <th>收货时间</th>
                <th>货号</th>
                <th>尺码</th>
                <th>数量</th>
                <th>备注</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="!logisticDetailListErr" v-for="(item, index) in logisticDetailList" :key="index">
                <td>{{item.CreateTime | time}}</td>
                <td>{{item.GoodsId}}</td>
                <td>{{item.Size}}</td>
                <td>{{item.Quantity}}</td>
                <td>{{item.Remark}}</td>
              </tr>
              <tr v-if="!logisticDetailListErr && !logisticDetailList.length">
                <td colspan="5">未找到该运单号的异常收货情况</td>
              </tr>
              <tr v-if="logisticDetailListErr">
                <td colspan="5">{{logisticDetailListErr}}</td>
              </tr>
              </tbody>
            </table>
            <!--物流图片-->
            <div class="logistic_img_msg">
              <p class="mb10">单号：<span class="fcDel">{{msg.ExpressNum}}</span>  &nbsp;&nbsp;&nbsp;&nbsp; 响应结果：<span class="fcDel">{{logisticImgListErr}}</span></p>
              <ul>
                <li v-for="(item, index) in logisticImgList" :key="index">
                  <img :src="item.url" @click="imgBig(item.url)">
                  <p>{{item.filename}}</p>
                  <p>{{item.uploadtime}}</p>
                  <p>{{item.uploader}}</p>
                </li>
              </ul>
            </div>
          </div>

          <!--弹出框底部-->
          <div class="select_dialog_embed_box_bottom">
            <button v-if="!afterSalesTypeOrderDetail && showType !== 'logisticNumDetail'" class="btn_normal" @click="submitBtn()">确定</button>
            <button v-if="afterSalesTypeOrderDetail" class="btn_normal" @click="saveRefundReType()">确定修改</button>
            <button class="btn_cancel" @click="cancelBtn(false)">取消</button>
          </div>
        </div>
      </div>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>
    </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

    export default {
        name: 'after-sales-embed-msg',
      /**
       *  title：  头部名
       *  showType:
       *  msg: 订单信息
       * */
      props: ['title', 'showType', 'msg'],
      components: {MsgDialog, LoadingDialog},
      computed: {
        refundCountInfo: {
          get: function () {
            return this.$store.state.refundCountInfo;
          },
          set: function (newVal) {
            this.$store.state.refundCountInfo = newVal;
            return this.$store.state.refundCountInfo;
          }
        }
      },
      data() {
        return {
          orderList: null, // 订单号列表
          selectOrderNum: null, // 选择的订单号
          orderMsg: {
            OrderDetailList: [] // 货品详情
          }, // 订单信息
          acceptanceChannelList: [], // 受理渠道列表
          selectAcceptanceChannel: '', // 选择的受理渠道
          channelReceivingInfo: null, // 渠道收货信息
          salesRemark: '', // 售后留言
          afterSalesTypeList: [], // 售后类型列表
          selectAfterSalesType: '', // 选择的售后类型
          afterSalesTypeOrderDetail: false, // 售后类型 = 退货/换货/漏发 时显示订单详细
          afterSalesReasonList: [], // 售后原因列表
          selectAfterSalesReason: '', // 选择的售后原因
          logList: [], // 日志列表
          logErr: null, // 日志申请错误
          courierCompanyList: [], // 快递公司下拉
          selectCourierCompany: '', // 选择的快递公司
          logisticNum: null, // 快递单号
          extraRefund: 0, // 额外退款的金额
          modifyRemark: null, // 编辑留言
          logisticDetailList: [], // 退回物流的详情列表
          logisticDetailListErr: null, // 退回物流的详情列表的错误
          logisticImgList: [], // 物流图片
          logisticImgListErr: null, // 物流图片错误
          isOriginalReturn: false, // 原返：有勾选原返的保存时自动将订单的运单号写入售后单中作为退运单号
          isLoading: false, // 是否显示加载框
          loadingType: 'NOP', // 加载页面类型
          isMsg: false, // 信息框显示
          isSuc: false, // 是否成功
          txtMsg: '信息框内容', // 信息框内容
          error: '' // 错误信息
        }
      },
      methods: {
        // 售后单撤回到(待受理)操作
        changeRefundStatus() {
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.changeRefundStatus(this.msg.RefundId), null).then((res) => {
            this.funCtrl(res);
          });
        },

        // 获取售后受理渠道下拉数据
        getBackStoreroomList() {
          this.$axios.get(this.Global.getBackStoreroomList(this.msg.RefundId)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.acceptanceChannelList = res.data.resData;
              this.selectAcceptanceChannel = this.msg.BackStoreroomId;
            } else {
              this.acceptanceChannelList = [];
              this.selectAcceptanceChannel = res.data.errorMsg;
            }
          });
        },

        // 根据渠道Id获取渠道收货信息
        getAgentStoreroomById() {
          this.$axios.post(this.Global.getAgentStoreroomById(this.selectAcceptanceChannel), null).then((res) => {
            if (!res.data.errorMsg.length) {
              if (res.data.resData) {
                this.channelReceivingInfo = res.data.resData.RefundAddress;
              } else {
                this.channelReceivingInfo = null;
              }
            }
          });
        },

        // 受理售后单
        shouLiRefund() {
          let refundMoney = 0;
          let isOrderBack = 0;
          if (this.isOriginalReturn) {
            isOrderBack = 1;
          } else {
            isOrderBack = 0;
          }

          if (this.msg.ReTypeName === '退货' || this.msg.ReTypeName === '换货' || this.msg.ReTypeName === '漏发') {
            if (!this.selectAcceptanceChannel) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请选择一个渠道';
              return;
            }
          }
          if (this.msg.PXExtMoney) {
            refundMoney = this.msg.PXExtMoney;
          }

          this.isLoading = true;
          this.loadingType = 'options';

          this.$axios.post(this.Global.shouLiRefund(this.msg.RefundId, this.selectAcceptanceChannel, isOrderBack, this.channelReceivingInfo, refundMoney, this.salesRemark), null).then((res) => {
            this.funCtrl(res);
          });
        },

        // 终止（关闭）售后单
        closeRefund() {
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.closeRefund(this.msg.RefundId), null).then((res) => {
            this.funCtrl(res);
          });
        },

        // 获取售后类型下拉框数据
        getRefundTypeList() {
          this.$axios.get(this.Global.getRefundTypeList).then((res) => {
            if (!res.data.errorMsg.length) {
              this.afterSalesTypeList = res.data.resData;
              this.selectAfterSalesType = this.msg.ReType;
            } else {
              this.afterSalesTypeList = [];
              this.selectAfterSalesType = res.data.errorMsg;
            }
          });
        },

        // 确认提交售后类型
        submitModifyRefundType() {
          if (this.selectAfterSalesType === 1 || this.selectAfterSalesType === 2) {
            this.saveRefundReType();
          } else {
            this.afterSalesTypeOrderDetail = true;
            this.getOrderRefundRelationList();
          }
        },

        // 对一笔售后单修改售后类型
        saveRefundReType() {
          let params;
          if (this.selectAfterSalesType === 1 || this.selectAfterSalesType === 2) {
            params = {
              RefundId: this.msg.RefundId,
              OrderId: this.msg.OrderId,
              ReType: this.selectAfterSalesType,
              RefundDetailBaseInfo: []
            }
          } else {
            params = {
              RefundId: this.msg.RefundId,
              OrderId: this.msg.OrderId,
              ReType: this.selectAfterSalesType,
              RefundDetailBaseInfo: []
            };
            for (let i = 0; i < this.orderMsg.OrderDetailList.length; i++) {
              if (this.orderMsg.OrderDetailList[i].isError && !this.orderMsg.OrderDetailList[i].errorGoodsNum && !this.orderMsg.OrderDetailList[i].errorSize) {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请将错发信息填写完整';
                return;
              }
              params.RefundDetailBaseInfo.push({
                OrderDetailId: this.orderMsg.OrderDetailList[i].Id,
                Quantity: this.orderMsg.OrderDetailList[i].Quantity,
                OfferFee: this.orderMsg.OrderDetailList[i].OfferFee,
                IsWrongSend: this.orderMsg.OrderDetailList[i].isError,
                WrongSendGoodsId: this.orderMsg.OrderDetailList[i].errorGoodsNum,
                WrongSendSize: this.orderMsg.OrderDetailList[i].errorSize
              });
            }
          }
          // console.log(params);
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.saveRefundReType, params).then((res) => {
            this.funCtrl(res);
          });
        },

        // 获取售后原因下拉框数据
        getRefundReasonList() {
          this.$axios.get(this.Global.getRefundReasonList).then((res) => {
            if (!res.data.errorMsg.length) {
              this.afterSalesReasonList = res.data.resData;
              this.selectAfterSalesReason = this.msg.RefundReasonId;
            } else {
              this.afterSalesReasonList = [];
              this.selectAfterSalesReason = res.data.errorMsg;
            }
          });
        },

        // 对一笔售后单修改售后原因
        saveRefundReason() {
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.saveRefundReason(this.msg.RefundId, this.selectAfterSalesReason), null).then((res) => {
            this.funCtrl(res);
          });
        },

        // 根据售后单号获取售后日志
        getRefundLogs() {
          this.$axios.post(this.Global.getRefundLogs(this.msg.RefundId), null).then((res) => {
            if (!res.data.errorMsg.length) {
              this.logList = res.data.resData.resData;
              if (!this.logList.length) {
                this.logErr = '暂时没有相关信息';
              }
            } else {
              this.logList = [];
              this.logErr = res.data.errorMsg;
            }
          });
        },

        // 对一笔售后单修改售后明细
        saveRefundDetails() {
          const params = {
            RefundId: this.msg.RefundId,
            // OrderId: this.msg.OrderId,
            OrderId: this.selectOrderNum,
            ReType: this.msg.ReType,
            RefundDetailBaseInfo: []
          };
          for (let i = 0; i < this.orderMsg.OrderDetailList.length; i++) {
            if (this.orderMsg.OrderDetailList[i].isError && !this.orderMsg.OrderDetailList[i].errorGoodsNum && !this.orderMsg.OrderDetailList[i].errorSize) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请将错发信息填写完整';
              return;
            }
            params.RefundDetailBaseInfo.push({
              OrderDetailId: this.orderMsg.OrderDetailList[i].Id,
              // Quantity: this.orderMsg.OrderDetailList[i].SendQuantity,
              Quantity: this.orderMsg.OrderDetailList[i].Quantity,
              OfferFee: this.orderMsg.OrderDetailList[i].OfferFee,
              IsWrongSend: this.orderMsg.OrderDetailList[i].isError,
              WrongSendGoodsId: this.orderMsg.OrderDetailList[i].errorGoodsNum,
              WrongSendSize: this.orderMsg.OrderDetailList[i].errorSize
            });
          }
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.saveRefundDetails, params).then((res) => {
            this.funCtrl(res);
          });
        },

        // 根据售后单号获取订单售后单关系数据
        getOrderRefundRelationList() {
          this.isLoading = true;
          // this.loadingType = 'options';
          this.orderList = [];
          this.$axios.post(this.Global.getOrderRefundRelationList(this.msg.RefundId), null).then((res) => {
            setTimeout(() => {
              this.isLoading = false;
              if (!res.data.errorMsg.length) {
                this.orderList = res.data.resData;
                // res.data.resData.map(item => {this.orderList.push(item.OrderId)});
                // res.data.resData.map((item, index) => {this.$set(this.orderList, index, item)});
                this.selectOrderNum = res.data.resData[0].OrderId;
                this.getOrderData(res.data.resData[0].OrderId);
              } else {
                this.orderList = [];
                this.selectOrderNum = res.data.errorMsg;
              }
            }, 1000)

          });
        },

        // 根据订单号加载订单数据（包含主单、订单明细、仓库信息、订单售后关系）
        getOrderData(orderNum) {
          // this.$axios.post(this.Global.getOrderData(this.selectOrderNum), null).then((res) => {
          this.$axios.post(this.Global.getOrderData(orderNum), null).then((res) => {
            this.isLoading = false;
            if (!res.data.errorMsg.length) {
              this.orderMsg = res.data.resData;
              this.$set(this.orderMsg, 'clinchADealUnitpriceCol', 0);
              this.$set(this.orderMsg, 'takeAUnitPriceOfGoodsCol', 0);
              let clinchADealUnitpriceCol = 0;
              let takeAUnitPriceOfGoodsCol = 0;
              for (let i = 0; i < this.orderMsg.OrderDetailList.length; i++) {
                this.$set(this.orderMsg.OrderDetailList[i], 'clinchADealUnitpriceRow', 0);
                this.$set(this.orderMsg.OrderDetailList[i], 'takeAUnitPriceOfGoodsRow', 0);
                this.$set(this.orderMsg.OrderDetailList[i], 'errorGoodsNum', null);
                this.$set(this.orderMsg.OrderDetailList[i], 'errorSize', null);
                this.$set(this.orderMsg.OrderDetailList[i], 'isError', false);
                // console.log('计算');
                // console.log('数量', this.orderMsg.OrderDetailList[i].Quantity);
                // console.log('成交单价', this.orderMsg.OrderDetailList[i].PayFee);
                // console.log('成交单价', this.orderMsg.OrderDetailList[i].UnitPrice);
                // console.log('数量*成交单价', this.Global.multiplication(this.orderMsg.OrderDetailList[i].Quantity, this.orderMsg.OrderDetailList[i].PayFee));
                // console.log('数量*成交单价', this.Global.multiplication(this.orderMsg.OrderDetailList[i].Quantity, this.orderMsg.OrderDetailList[i].UnitPrice));
                // console.log('优惠金额', this.orderMsg.OrderDetailList[i].OfferFee);
                // this.orderMsg.OrderDetailList[i].clinchADealUnitpriceRow = this.Global.subtraction(this.Global.multiplication(this.orderMsg.OrderDetailList[i].Quantity, this.orderMsg.OrderDetailList[i].PayFee), this.orderMsg.OrderDetailList[i].OfferFee);
                this.orderMsg.OrderDetailList[i].clinchADealUnitpriceRow = this.Global.subtraction(this.Global.multiplication(this.orderMsg.OrderDetailList[i].Quantity, this.orderMsg.OrderDetailList[i].UnitPrice), this.orderMsg.OrderDetailList[i].OfferFee);
                // console.log('合计', this.orderMsg.OrderDetailList[i].clinchADealUnitpriceRow);
                this.orderMsg.OrderDetailList[i].takeAUnitPriceOfGoodsRow = this.Global.multiplication(this.orderMsg.OrderDetailList[i].Quantity, this.orderMsg.OrderDetailList[i].AgentCostPrice);
                clinchADealUnitpriceCol = this.Global.addition(clinchADealUnitpriceCol, this.orderMsg.OrderDetailList[i].clinchADealUnitpriceRow);
                takeAUnitPriceOfGoodsCol = this.Global.addition(takeAUnitPriceOfGoodsCol, this.orderMsg.OrderDetailList[i].takeAUnitPriceOfGoodsRow);
              }
              this.orderMsg.clinchADealUnitpriceCol = clinchADealUnitpriceCol;
              this.orderMsg.takeAUnitPriceOfGoodsCol = takeAUnitPriceOfGoodsCol;
            }
          });
        },

        // 改变数量
       /* changeQuantity(index) {
          if (!parseInt(this.orderMsg.OrderDetailList[index].SendQuantity)) {
            this.orderMsg.OrderDetailList[index].SendQuantity = 0;
          }
          this.orderMsg.OrderDetailList[index].SendQuantity = parseInt(this.orderMsg.OrderDetailList[index].SendQuantity);
          this.orderMsg.OrderDetailList[index].clinchADealUnitpriceRow =
            // this.Global.subtraction(this.Global.multiplication(this.orderMsg.OrderDetailList[index].Quantity, this.orderMsg.OrderDetailList[index].PayFee), this.orderMsg.OrderDetailList[index].OfferFee);
            this.Global.subtraction(this.Global.multiplication(this.orderMsg.OrderDetailList[index].Quantity, this.orderMsg.OrderDetailList[index].UnitPrice), this.orderMsg.OrderDetailList[index].OfferFee);

          this.orderMsg.clinchADealUnitpriceCol = 0;
          for (let i = 0; i < this.orderMsg.OrderDetailList.length; i++) {
            this.orderMsg.clinchADealUnitpriceCol = this.Global.addition(this.orderMsg.clinchADealUnitpriceCol, this.orderMsg.OrderDetailList[i].clinchADealUnitpriceRow);
          }
        }, */

        // 改变数量
        changeQuantity(index) {
          if (!parseInt(this.orderMsg.OrderDetailList[index].Quantity)) {
            this.orderMsg.OrderDetailList[index].Quantity = 0;
          }
          this.orderMsg.OrderDetailList[index].Quantity = parseInt(this.orderMsg.OrderDetailList[index].Quantity);
          this.orderMsg.OrderDetailList[index].clinchADealUnitpriceRow =
            // this.Global.subtraction(this.Global.multiplication(this.orderMsg.OrderDetailList[index].Quantity, this.orderMsg.OrderDetailList[index].PayFee), this.orderMsg.OrderDetailList[index].OfferFee);
            this.Global.subtraction(this.Global.multiplication(this.orderMsg.OrderDetailList[index].Quantity, this.orderMsg.OrderDetailList[index].UnitPrice), this.orderMsg.OrderDetailList[index].OfferFee);

          this.orderMsg.clinchADealUnitpriceCol = 0;
          for (let i = 0; i < this.orderMsg.OrderDetailList.length; i++) {
            this.orderMsg.clinchADealUnitpriceCol = this.Global.addition(this.orderMsg.clinchADealUnitpriceCol, this.orderMsg.OrderDetailList[i].clinchADealUnitpriceRow);
          }
        },

        // 删除货品列表数据
        delOrderGoods(i) {
          this.orderMsg.OrderDetailList.splice(i, 1);
        },

        // 获取快递公司下拉框
        getAllLogisticList() {
          this.$axios.get(this.Global.getAllLogisticList).then((res) => {
            console.log(res);
            if (!res.data.errorMsg.length) {
              this.courierCompanyList = res.data.resData;
              this.selectCourierCompany = this.msg.LogisticId;
            } else {
              this.courierCompanyList = [];
              this.selectCourierCompany = res.data.errorMsg;
            }
          });
        },

        // 判断是否为数字类型
        judgeNum() {
          if (typeof this.extraRefund !== 'number') {
            this.extraRefund = 0;
          }
        },

        // 检验退回物流单号是否被其他售后单使用
        checkRefundExpressNumIsUsed() {
          this.$axios.post(this.Global.checkRefundExpressNumIsUsed(this.msg.RefundId, this.selectCourierCompany, this.logisticNum), null).then((res) => {
            if (!res.data.errorMsg.length) {
              this.saveRefundLogisticInfo();
            } else {
              this.txtMsg = '退回物流';
              this.error = res.data.errorMsg + '，';
              // this.isMsg = true;
              // this.isSuc = false;
              // this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 保存退回物流信息
        saveRefundLogisticInfo() {
          if (!this.logisticNum) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入退货运单号';
            return;
          }
          if (!this.extraRefund) {
            this.extraRefund = 0;
          }
          this.isLoading = true;
          this.loadingType = 'options';
          if (this.showType === 'returnLogistic') {
            this.$axios.post(this.Global.saveRefundLogisticInfo(this.msg.RefundId, this.selectCourierCompany, this.logisticNum, this.extraRefund, 0), null).then((res) => {
              this.funCtrl(res);
              if (!res.data.errorMsg.length) {
                this.txtMsg = '';
              }
            });
          } else {
            this.$axios.post(this.Global.saveRefundLogisticInfo(this.msg.RefundId, this.selectCourierCompany, this.logisticNum, this.extraRefund, 1), null).then((res) => {
              this.funCtrl(res);
              if (!res.data.errorMsg.length) {
                this.txtMsg = '';
              }
            });
          }
        },

        // 提交退款金额（分销商向买家退款）
        saveRefundTuiMoney() {
          if (!this.extraRefund && this.extraRefund !== 0) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入金额';
            return;
          }
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.saveRefundTuiMoney(this.msg.RefundId, this.extraRefund), null).then((res) => {
            this.funCtrl(res);
          });
        },

        // 修改分销商额外退费金额
        saveAgentPXExtMoney() {
          if (!this.extraRefund && this.extraRefund !== 0) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入金额';
            return;
          }
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.saveAgentPXExtMoney(this.msg.RefundId, this.extraRefund), null).then((res) => {
            this.funCtrl(res);
          });
        },

        // 修改分销商内部备注
        saveAgentRemark() {
          if (!this.modifyRemark) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入留言';
            return;
          }
          this.isLoading = true;
          this.loadingType = 'options';
          this.$axios.post(this.Global.saveAgentRemark(this.msg.RefundId, this.modifyRemark), null).then((res) => {
            this.funCtrl(res);
          });
        },

        // 根据渠道、运单号获取异常收货数据
        getRefundDailyReturnGoods() {
          this.$axios.post(this.Global.getRefundDailyReturnGoods(this.msg.BackStoreroomId, this.msg.ExpressNum), null).then((res) => {
            if (!res.data.errorMsg.length) {
              this.logisticDetailList = res.data.resData;
            } else {
              this.logisticDetailListErr = res.data.errorMsg;
            }
          });
        },

        // 根据运单号获取图片信息
        getImgById() {
          this.$axios.get(this.Global.getImgById(this.msg.ExpressNum), null).then((res) => {
          // this.$axios.get(this.Global.getImgById('SF3236354510941'), null).then((res) => {
          //   console.log(res);
          //   if (!res) return;
            if (!res.data.errorMsg.length) {
              this.logisticImgList = res.data.resData;
              this.logisticImgListErr = '成功';
            } else {
              this.logisticImgListErr = res.data.errorMsg;
            }
          });
        },

        // 查看确认收货列表
        getRefundLogisticData() {
          this.$axios.post(this.Global.getRefundLogisticData(this.msg.RefundId), null).then((res) => {
            if (!res.data.errorMsg.length) {
              this.logisticDetailList = res.data.resData;
            } else {
              this.logisticDetailListErr = res.data.errorMsg;
            }
          });
        },

        // 售后单确认收货
        confirmReceipt() {
          this.$axios.post(this.Global.confirmReceipt(this.msg.RefundId), null).then((res) => {
            this.funCtrl(res);
          });
        },

        // 售后单重新提交
        refundResubmit() {
          this.$axios.post(this.Global.refundResubmit(this.msg.RefundId), null).then((res) => {
            this.funCtrl(res);
          });
        },

        // 创建换货新订单
        createNewOrder() {
          this.$axios.post(this.Global.createNewOrder(this.msg.RefundId), null).then((res) => {
            this.funCtrl(res);
          });
        },

        // 获取修改换货新订单列表
        getCreateNewOrder() {
          this.$axios.post(this.Global.getCreateNewOrder(this.msg.RefundId), null).then((res) => {
            if (!res.data.errorMsg.length) {
              this.orderList = res.data.resData;
            }
          });
        },

        // 创建换货新订单（新版）
        newCreateNewOrder() {
          this.isLoading = true;
          let params = [];
          // console.log(this.orderList);
          for (let i = 0; i < this.orderList.length; i++) {
            params.push({
              GuId: this.orderList[i].GuId,
              GoodsId: this.orderList[i].GoodsId,
              ColorName: this.orderList[i].ColorName ? this.orderList[i].ColorName : '',
              SizeName: this.orderList[i].SizeName ? this.orderList[i].SizeName : ''
            })
          }
          this.$axios.post(this.Global.newCreateNewOrder(this.msg.RefundId), params).then((res) => {
            this.funCtrl(res);
          });
        },

        // 改货 根据货号获取品名和零售价
        getGoodsInfoByGoodsId(val, index) {
          this.$axios.post(this.Global.getGoodsInfoByGoodsId(val), null).then((res) => {
            if (!res.data.errorMsg.length) {
              // this.goodsDetailList[index].Quantity = 0;
              // this.goodsDetailList[index].UnitPrice = 0;
              this.orderList[index].GoodsName = res.data.resData.GoodsName;
              this.orderList[index].ColorName = res.data.resData.ColorName;
              this.orderList[index].SizeName = res.data.resData.ColorName;
            } else {
              // this.goodsDetailList[index].Quantity = null;
              // this.goodsDetailList[index].UnitPrice = null;
              this.orderList[index].GoodsName = '';
              this.orderList[index].ColorName = '';
              this.orderList[index].SizeName = '';
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 获取分销商的售后统计数据
        getRefundCountInfo() {
          this.$axios.get(this.Global.getRefundCountInfo).then((res) => {
            if (!res.data.errorMsg.length) {
              this.refundCountInfo = res.data.resData.refundCountInfo;
              this.$store.commit('updateAfterOrder', this.refundCountInfo);
            }
          });
        },

        // 点击图片打开新标签
        imgBig(url) {
          window.open(url, '_blank');
        },

        // 操作方法
        funCtrl(res) {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (!res.data.errorMsg.length) {
              self.isMsg = true;
              self.isSuc = true;
              self.txtMsg = '操作成功';
              self.cancelBtn(true);
              if (self.showType === 'toAccept' || self.showType === 'closeSalesAfter') {
                self.getRefundCountInfo();
              }
            } else {
              self.isMsg = true;
              self.isSuc = false;
              self.txtMsg = res.data.errorMsg;
            }
          }, 500);
        },

        // 提交按钮
        submitBtn() {
          if (this.showType === 'pullBack') {
            this.changeRefundStatus();
          } else if (this.showType === 'toAccept') {
            this.shouLiRefund();
          } else if (this.showType === 'closeSalesAfter') {
            this.closeRefund();
          } else if (this.showType === 'modifySalesReasonList') {
            this.saveRefundReason();
          } else if (this.showType === 'modifyAfterSalesType') {
            this.submitModifyRefundType();
          } else if (this.showType === 'modifySalesDetail') {
            this.saveRefundDetails();
          } else if ((this.showType === 'modifyReturnLogistic' || this.showType === 'returnLogistic') && this.txtMsg !== '退回物流') {
            this.checkRefundExpressNumIsUsed();
            // this.saveRefundLogisticInfo();
          } else if ((this.showType === 'modifyReturnLogistic' || this.showType === 'returnLogistic') && this.txtMsg === '退回物流') {
            // this.checkRefundExpressNumIsUsed();
            this.saveRefundLogisticInfo();
          } else if (this.showType === 'extraRefund') {
            this.saveAgentPXExtMoney();
          } else if (this.showType === 'buyerRefundedAmount') {
            this.saveRefundTuiMoney();
          } else if (this.showType === 'modifyRemark') {
            this.saveAgentRemark();
          } else if (this.showType === 'confirmReceipt') {
            this.confirmReceipt();
          } else if (this.showType === 'resubmit') {
            this.refundResubmit();
          } else if (this.showType === 'createExchange') {
            // this.createNewOrder();
            this.newCreateNewOrder();
          } else {
            this.cancelBtn(false);
          }
        },

        // 取消按钮
        cancelBtn(type) {
          this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
        },

        // 接收提示框传送的数据
        closeMsgDialog(e) {
          this.isMsg = e;
          if (this.isSuc) {
            this.cancelBtn(true);
          }
        }

      },
      created() {
        this.getCreateNewOrder();
        if (this.showType === 'log') {
          this.getRefundLogs();
        } else if (this.showType === 'modifyAfterSalesType') {
          this.getRefundTypeList();
        } else if (this.showType === 'modifySalesReasonList') {
          this.getRefundReasonList();
        } else if (this.showType === 'modifySalesDetail') {
          console.log('modifySalesDetail：', this.msg.OrderId);
          this.getOrderRefundRelationList();
          this.selectOrderNum = this.msg.OrderId;
          // this.getOrderData(this.msg.OrderId);
        } else if (this.showType === 'modifyReturnLogistic' || this.showType === 'returnLogistic') {
          this.getAllLogisticList();
          this.logisticNum = this.msg.ExpressNum;
          this.extraRefund = this.msg.PXExtMoney;
        } else if (this.showType === 'buyerRefundedAmount') {
          this.extraRefund = this.msg.TuiMoney;
        } else if (this.showType === 'extraRefund') {
          this.extraRefund = this.msg.PXExtMoney;
        } else if (this.showType === 'modifyRemark') {
          this.modifyRemark = this.msg.AgentRemark;
        } else if (this.showType === 'toAccept') {
          console.log(this.msg);
          this.getBackStoreroomList();
          if (this.msg.BackStoreroomId) {
            this.selectAcceptanceChannel = this.msg.BackStoreroomId;
            this.getAgentStoreroomById();
          }
          if (this.msg.RefundReasonId === 1) {
            this.msg.PXExtMoney = 0;
          }
        } else if (this.showType === 'logisticNumDetail') {
          this.getRefundDailyReturnGoods();
          this.getImgById();
        } else if (this.showType === 'confirmReceipt') {
          this.getRefundLogisticData();
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .after_sales_embed_msg {
    background-color: #fff;
    max-height: 100%;

    &.topWpre5 {
      position: absolute;
      top: 5%;
    }

    &.w_percent96 {
      width: 96%;
    }

    .select_dialog_embed_box {

      &.w650 {
        width: 650px;
      }

      &.w800 {
        width: 800px;
      }

      &.w_percent100 {
        width: 100%;
      }

      .log {
        padding: 10px;
        max-height: 500px;
        overflow-y: auto;

        table {
          td:nth-child(3) {
            text-align: left;
          }
        }
      }

      .select_dialog_embed_box_content {
        .table {
          margin: 0 auto;

          thead, tbody tr {
            display: table;
            width: 100%;
            table-layout: fixed;

            th, td {
              padding: 10px;
              border-right: 1px solid #ddd;

              &:last-child {
                border-right: none;
              }
            }
          }

          tbody {
            display: block;
            width: 100%;
            max-height: 450px;
            overflow-y: auto;
          }
        }

        .logistic_img_msg {
          margin-top: 10px;

          ul {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            gap: 28px;  /* 项间距 */
            text-align: center;

            li {
              flex: 0 20%;

              img {
                width: 160px;
                height: 160px;
                cursor: pointer;
              }

              p {
                text-align: left;
                margin: 5px 0;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/after-sales-embed-msg.vue